import Select from "react-select";


export const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid #7117E5" : "1px solid #BCC1DE",
      borderRadius: "4px",
      padding: "5px",
      transition: "border-color 0.2s ease",
      maxWidth: "100%",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#f0f0f0"
        : state.isSelected
        ? "#26A65B"
        : "white",
      color: state.isSelected ? "#010D14" : "#333",
      cursor: "pointer",
      padding: "10px",
      indicatorSeparator: (styles) => ({display:'none'})
    }),
    placeholder: (provided) => ({
      ...provided,
    //   color: "#888",
      color: "fff000"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333",
    }),
  };


  export const CustomSelect = (props) => (
    <div
        className="react-select__container"
        onClick={(e) => e.stopPropagation()}
    >
        <Select
            {...props}
            styles={{
                ...selectStyles,
                container: (provided) => ({
                    ...provided,
                    width: "100%",
                    maxWidth: "100%",
                }),
            }}
            components={{
                IndicatorSeparator: () => null,
                ...props.components,
            }}
        />
    </div>
);